
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Marquee from '../Marquee';
import 'bootstrap/dist/css/bootstrap.min.css';
import './HeaderComp1.css';
import { NavLink } from 'react-router-dom';
import Reviews from '../Reviews';

const HeaderComp1 = () => {
  const [bannerData, setBannerData] = useState([]);
  const [topMiddle, setTopMiddle] = useState(null);
  

  useEffect(() => {
    axios
      .get('https://api.bakpoket.com/api/TopBanner/get-top-banners')
      .then((res) => {
        
        const data = res.data;
        setBannerData([...data, ...data]);
      })
      .catch((err) => console.error('Error fetching banners:', err));
  }, []);

  useEffect(() => {
    axios
      .get('https://api.bakpoket.com/api/TopBanner/TTC_Images/TopMiddle')
      .then((res) => {setTopMiddle(...res.data)})
      .catch((err) => console.error('Error fetching Left Ad:', err));
  }, []);


  return (
    <div className="container-fluid" style={{ backgroundColor: '#fff' }}>
      <div className="container px-lg-4 py-lg-2 py-1">
        <div className="row d-flex  align-items-center">
          <div className="col">
            <div className='row'>
            <div className='col-5 text-start d-flex align-items-center'>
            <NavLink to='/'>
            <img
              src="/images/bakpoket-toplogo.png"
              alt="Bakpoket Logo"
              className="img-fluid logo-img"
            />
            </NavLink>
            </div>
            <div className='col-7 text-center d-flex '>
              <div className='d-flex justify-content-between flex-column'>
                {topMiddle && (
                  <a
                    href={`https://${topMiddle.merchantURL}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`data:image/png;base64,${topMiddle.imageBase64}`}
                      className="img-fluid w-100"
                      alt="Center Ad"
                      style={{height:'auto'}}
                    />
                  </a>
                )}
                <Reviews/>
              </div>
            </div>
            </div>
          </div>
          <div className="col-6 text-end">
            <Marquee />
            <div className="slider-wrapper-banner mt-2">
              <div className="slider-track">
                {bannerData.map((banner, index) => {
                  const imageSrc = `data:${banner.contentType};base64,${banner.base64Image}`;
                  return banner.merchantURL ? (
                    <a
                      key={index}
                      href={banner.merchantURL.startsWith('http') ? banner.merchantURL : `https://${banner.merchantURL}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={imageSrc} alt={banner.fileName} />
                    </a>

                      
                  ) : (
                    <img key={index} src={imageSrc} alt={banner.fileName} />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderComp1;
